const removeUrls = (inputString, userId = null) => {
  const userIds = ['alim.support@alim.org'];

  // Matches URLs with http(s), www, or plain domain formats like surah-al-waqiah.com/surah
  const urlPattern = /\b(?:https?:\/\/|www\.)?\w[\w.-]+\.\w{2,}(?:\/[^\s<]*)?/gi;

  // Matches HTML tags
  const htmlTagPattern = /<\/?[^>]+(>|$)/g;

  // Check if a URL belongs to alim.org
  const isFromAlim = (url) => {
    try {
      const urlWithProtocol = url.startsWith('http') ? url : `https://${url}`;
      const urlObj = new URL(urlWithProtocol);
      const hostname = urlObj.hostname;
      return hostname === 'alim.org' || hostname.endsWith('.alim.org');
    } catch (e) {
      return false;
    }
  };

  // Allow full content for certain users
  if (userIds.includes(userId)) {
    return inputString.replace(htmlTagPattern, '').trim();
  }

  // Remove third-party URLs, keep alim.org links
  const withoutUrls = inputString.replace(urlPattern, (url) => {
    return isFromAlim(url) ? url : '';
  });

  return withoutUrls.replace(htmlTagPattern, '').trim();
};

export default removeUrls;